import React from "react";

const Hero = ({ title, tagline }) => {
  return (
    <section className="flex-1 flex flex-col justify-center items-center bg-gradient-to-br from-red-500 to-yellow-500 text-white py-20">
      <h2 className="text-4xl md:text-6xl font-extrabold drop-shadow-md">
        {title || "Restaurant Name"}
      </h2>
      <p className="mt-4 text-lg bg-white bg-opacity-10 px-6 py-3 rounded">
        {tagline || "Taste the Difference"}
      </p>
    </section>
  );
};

export default Hero;
